// extracted by mini-css-extract-plugin
export default {"returnsAndExchangesUPSPickUpAddress":"b3-z","columnTitle":"c3-z","addressDetails":"d3-z"};